<template>
    <div class="contact-us-box">
        <div class="contact-us-main">
            <i class="logo"></i>
            <div class="contact-brands">
                <div class="title">{{ $Getlanguage('Contact Information') }}</div>
                <div class="brand-list">
                    <div class="brand-item" v-for="(item,index) in brandsArr" :key="index">
                        <span>{{ $Getlanguage(item.name)}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    const brandsArr = [
        {
            name: 'Brand Cooperation'
        },
        {
            name: 'Business Cooperation'
        },
        {
            name: 'Recruitment Contact'
        },
        {
            name: 'Supply Chain'
        },
    ]
</script>

<style lang="scss" scoped>
.contact-us-box {
    width: 100%;
    height: 253px;
    background: #a1824d;
    padding: 0 160px;
    box-sizing: border-box;
    .contact-us-main {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        .logo {
            flex-shrink: 0;
            display: inline-block;
            width: 405px;
            height: 107px;
            background: url($imgUrl + '/logo1.png?v=1') no-repeat center;
            background-size: contain;
            margin-left: 10px;
        }
        .contact-brands {
            margin-left: 123px;
            .title {
                font-size: 30px;
                font-weight: 700;
                color: #20201f;
            }
            .brand-list {
                display: flex;
                align-items: center;
                margin-top: 30px;
                flex-wrap: wrap;
                .brand-item {
                    font-size: 30px;
                    font-weight: 400;
                    text-align: center;
                    color: #ffffff;
                    padding: 0 100px 5px 0;
                    white-space: nowrap;
                    &:last-child {
                        padding-right: 0;
                    }
                }
            }
        }
    }
}
</style>